import { Controller } from '@hotwired/stimulus'
import { FetchRequest } from '@rails/request.js'

export default class extends Controller {
  static targets = ['input']
  static values = { formatUrl: String }

  #rawValue = null

  focus() {
    if (this.#rawValue !== null) {
      this.inputTarget.value = this.#rawValue
    }
  }

  async format() {
    const raw = this.inputTarget.value.trim()
    if (!raw) {
      this.#rawValue = null
      return
    }

    this.#rawValue = raw

    const request = new FetchRequest(
      'get',
      `${this.formatUrlValue}?text=${encodeURIComponent(raw)}`,
      { responseKind: 'json' },
    )

    const response = await request.perform()
    if (response.ok) {
      const { duration } = await response.json
      if (duration) this.inputTarget.value = duration
    }
  }
}
